import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { hooks } from '@febos-io/common';
import { utils } from '@febos-io/design';

import { resetPasswordUpdate } from '../config';
import useTranslation from './useTranslation';
import { useAuthContext } from '../providers';

export function useResetPasswordUpdate() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { signInPathname } = useAuthContext();

  const { callback: onSubmit, loading } = hooks.useRequestCallback(
    useCallback(
      async (request, { code, password, newPassword }) => {
        const response = await request.exec(resetPasswordUpdate(code, password, newPassword));
        if (response.code === 10) {
          utils.success(t('Password Reset Successfully'));
          navigate(signInPathname);
        } else {
          utils.error(t('Something went wrong'));
        }
      },
      [navigate, signInPathname, t]
    )
  );

  return {
    loading,
    onSubmit
  };
}
